export interface Invitation {
  subject: string;
  body: string;
}

export const generateMailLink = async (invitation: Invitation) => {
  return `mailto:?subject=${encodeURIComponent(invitation.subject)}&body=${encodeURIComponent(invitation.body)}`;
};
